import {t} from '@lingui/core/macro';

export const getAddTagError = (error: unknown): string => {
    const message = typeof error === 'string' ? error.trim() : '';

    return message || t`Не удалось создать тег`;
};
